import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { NumberComponent } from '@web/shared/ui';

@Component({
  selector: 'app-refunded-quantity',
  imports: [NumberComponent],
  templateUrl: './refunded-quantity.component.html',
  styleUrl: './refunded-quantity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefundedQuantityComponent {
  public readonly originalQuantity = input.required<number>();
  public readonly refundedQuantity = input.required<number>();
  public readonly currentQuantity = input.required<number>();
}
